const STRING_LENGTH_REGEX = '/^(?=.{<min>,<max>}$).*/'

export const getStringLengthRegex = (min = 2, max = 100) => {
  return STRING_LENGTH_REGEX.replace('<min>', min).replace('<max>', max)
}
